import {SECURE_COOKIE_SESSION_TOKEN_KEY, SECURE_COOKIE_SESSION_TOKEN_KEY_LOCAL} from '@/lib/constants';

export const secureCookieApiKey = () => {
    const isClient = globalThis.window !== undefined;
    if (isClient && process.env.NEXT_PUBLIC_NODE_ENV === 'development') {
        return SECURE_COOKIE_SESSION_TOKEN_KEY_LOCAL;
    }

    if (!isClient && process.env.NODE_ENV === 'development') {
        return SECURE_COOKIE_SESSION_TOKEN_KEY_LOCAL;
    }

    return SECURE_COOKIE_SESSION_TOKEN_KEY;
};

export const diffInSeconds = (date1: Date, date2: Date) => {
    const diff = (date1.getTime() - date2.getTime()) / 1000;
    return Math.abs(Math.round(diff));
};
